import { render, staticRenderFns } from "./TimestampPage.vue?vue&type=template&id=ad7dfb48&scoped=true"
import script from "./TimestampPage.vue?vue&type=script&lang=js"
export * from "./TimestampPage.vue?vue&type=script&lang=js"
import style0 from "./TimestampPage.vue?vue&type=style&index=0&id=ad7dfb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7dfb48",
  null
  
)

export default component.exports